import React from 'react';
import { Link } from 'react-router-dom';
import { PublicHeader, PublicFooter } from '../components/PublicLayout';
import { Button } from '../components/ui/button';
import { Search, Home, ArrowLeft } from 'lucide-react';

export default function NotFoundPage() {
  return (
    <>
      <PublicHeader />
      <main className="bg-[#FBF7EF] min-h-screen flex items-center justify-center">
        <div className="text-center px-4 max-w-lg">
          <div className="text-8xl font-bold text-[#E7E0D6] mb-4 news-masthead">404</div>
          <h1 className="text-2xl font-bold mb-2">Page Not Found</h1>
          <p className="text-[#5B616E] mb-8">The article or page you're looking for doesn't exist or may have been moved.</p>
          <div className="flex gap-3 justify-center">
            <Link to="/">
              <Button className="bg-[#121316] text-white hover:bg-[#1B1D22]">
                <Home className="w-4 h-4 mr-2" /> Go Home
              </Button>
            </Link>
            <Link to="/search">
              <Button variant="outline" className="border-[#E7E0D6]">
                <Search className="w-4 h-4 mr-2" /> Search
              </Button>
            </Link>
          </div>
        </div>
      </main>
      <PublicFooter />
    </>
  );
}
